import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetProjectSurveyNamesRPC } from "./getProjectSurveyNamesRPC";

export class GetProjectSurveyNamesRPCClientImpl extends GetProjectSurveyNamesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetProjectSurveyNamesRPC.Request): Promise<LeoRPCResult<GetProjectSurveyNamesRPC.Response, GetProjectSurveyNamesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetProjectSurveyNames",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetProjectSurveyNamesRPC.ResponseDTO,
      GetProjectSurveyNamesRPC.Errors.ErrorsDTO,
      GetProjectSurveyNamesRPC.Response,
      GetProjectSurveyNamesRPC.Errors.Errors
    >(
      response,
      "project/GetProjectSurveyNames",
      GetProjectSurveyNamesRPC.Response.fromDTO,
      GetProjectSurveyNamesRPC.Errors.fromDTO
    );
  }
}
